export enum CodeMirrorMode {
  Javascript = 'javascript',
  CSS = 'css',
  HTML = 'htmlmixed'
}
